import React, { useState, useEffect, useRef } from 'react';
import ViewFlowBoard from './view_flow_board';
import ViewFlowDetailed from './view_flow_detailed';
import ViewFlowManage from './view_flow_manage';
import { fetchMetadataCategoriesHierarchical } from '../moduleServices/flow_requests';
import ModalFlowAdd from './viewComponents/Common/ModalFlowAdd';
import ModalFlowEdit from './viewComponents/Common/ModalFlowEdit';
import { PlusCircleIcon } from '@heroicons/react/24/solid';

// ###### MAIN COMPONENT
const TabFinanceFlow = ({ activeTabL1, yearsRange }) => {

  // ###### STATES
  const [categories, setCategories] = useState({});

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState(null);

  // ###### API REQUESTS
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchMetadataCategoriesHierarchical();
        setCategories(data);
      } catch (error) {
        console.error('Error loading categories:', error);
      }
    };

    loadCategories();
  }, []);

  // ###### HANDLERS
  const handleFlowClick = (flow) => {
    setSelectedFlow(flow);
  };

  const flowsUpdateRef = useRef(null);

  const handleModalSuccess = () => {
    if (flowsUpdateRef.current) {
      flowsUpdateRef.current();
    }
  };

  // ###### RETURN VIEW
  return (
    <>

      {/* Board */}
      {activeTabL1 === 'board' && (
        <div className="flex justify-center items-center gap-0 w-full mt-2">
          <ViewFlowBoard
            flowsUpdateRef={flowsUpdateRef}
            onFlowClick={handleFlowClick}
            yearsRange={yearsRange}
          />
        </div>
      )}

      {/* Detailed */}
      {activeTabL1 === 'detailed' && (
        <ViewFlowDetailed 
          hierarchicalCategories={categories}
          onFlowClick={handleFlowClick}
          flowsUpdateRef={flowsUpdateRef}
        />
      )}

      {/* Manage */}
      {activeTabL1 === 'manage' && (
        <div className="flex justify-center items-center gap-0 w-full mt-2">
          <ViewFlowManage />
        </div>
      )}

      {/* FAB Button Add */}
      <button
        onClick={() => setIsAddModalOpen(true)}
        className="fixed bottom-20 right-6 bg-green-800 hover:bg-green-900 text-white p-3 rounded-full shadow-lg"
      >
        <PlusCircleIcon className="h-8 w-8" />
      </button>

      {/* Modals Add and Edit */}
      <ModalFlowAdd
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={handleModalSuccess}
        categories={Object.keys(categories)}
        hierarchicalCategories={categories}
      />

      <ModalFlowEdit
        selectedFlow={selectedFlow}
        onClose={() => setSelectedFlow(null)}
        onSuccess={handleModalSuccess}
        categories={Object.keys(categories)}
        hierarchicalCategories={categories}
      />

    </>
  );
};

export default TabFinanceFlow;
